"use strict";

define('app/legacyupload/legacy.upload.view',['rs/abstract.content.view'], function (RSAbstractContentView) {
  var LegacyUploadView = RSAbstractContentView.extend({
    templates: {
      'legacy.upload.init': 'renderInitFragment',
      'legacy.result.group': 'renderResultGroupFragment',
      'legacy.pdf.results': 'renderPDFResults'
    },
    events: {
      'click .wizard-nav.activated': 'handleWizardNavClick',
      'click .dropped-file .fa-icon-times': 'handleRemoveFile',
      'click [data-wizard-action]': 'handleWizardActionClick',
      'click .result-details-btn': 'handleToggleDisplayDetails'
    },
    selectors: {
      file: '.dropped-file',
      fileName: '.dropped-file .file-name',
      hiddenInput: '.hidden-file-upload',
      results: '.legacy-validation-results',
      resultsCount: '.legacy-results-count'
    },
    render: function render() {
      var templateProps = this.getDelegate().getTemplateProperties();
      this.$el.html(this.renderInitFragment(templateProps));
      this.setupFileHandlers();
      this.setRendered();
    },
    renderValidationResults: function renderValidationResults() {
      var results = this.$(this.selectors.results),
        validation = this.getDelegate().getResultProperties(),
        count = 0;
      results.html('');
      for (var i = 0, len = validation.length; i < len; i++) {
        count += validation[i].results.length;
        results.append(this.renderResultGroupFragment(validation[i]));
      }
      this.$(this.selectors.resultsCount).html(count + ' Records');
    },
    handleWizardActionClick: function handleWizardActionClick(ev) {
      var action = $(ev.currentTarget).data('wizard-action');
      this['triggerStep' + action]();
    },
    handleWizardNavClick: function handleWizardNavClick(ev) {
      var activatePaneName = $(ev.currentTarget).data('wizard-step'),
        activatePane = this.getWizardPane(activatePaneName);
      if (!activatePane.is(':visible')) {
        if (activatePaneName == 'results') {
          this.triggerStepValidateFile();
        } else if (activatePaneName == 'upload') {
          this.triggerStepReturnToUpload();
        }
      }
    },
    triggerStepValidateFile: function triggerStepValidateFile() {
      this.getDelegate().requestValidateFile();
    },
    triggerStepReturnToUpload: function triggerStepReturnToUpload() {
      this.showWizardPane('upload');
    },
    triggerStepSubmitFile: function triggerStepSubmitFile() {
      this.getDelegate().requestUploadFile();
    },
    triggerStepNavigateToStudies: function triggerStepNavigateToStudies() {
      this.getDelegate().getAppController().navigateNewStudyList({
        trigger: true
      });
    },
    handleRemoveFile: function handleRemoveFile(ev) {
      ev.stopPropagation();
      this.prepareFile(null);
    },
    handleToggleDisplayDetails: function handleToggleDisplayDetails(ev) {
      var el = $(ev.currentTarget),
        toggleEl = el.parent().next('.result-details');
      if (toggleEl.is(':visible')) {
        el.find('.fa-icon').removeClass('fa-icon-caret-down').addClass('fa-icon-caret-right');
        toggleEl.slideUp();
      } else {
        el.find('.fa-icon').removeClass('fa-icon-caret-right').addClass('fa-icon-caret-down');
        toggleEl.slideDown();
      }
    },
    prepareFile: function prepareFile(file) {
      var el = this.$(this.selectors.file),
        hiddenInput = this.$(this.selectors.hiddenInput);
      this.getDelegate().setFile(file);
      hiddenInput.val('');
      this.updateWizardActions();
      if (file) {
        this.$(this.selectors.file).css('display', 'inline-block');
        this.$(this.selectors.fileName).text(file.name);
      } else {
        this.$(this.selectors.file).hide();
      }
    },
    setupFileHandlers: function setupFileHandlers() {
      var that = this,
        hiddenInput = this.$(this.selectors.hiddenInput),
        handleFileHover = function handleFileHover(hover) {
          if (hover) {
            that.$('.drop-zone').addClass('hover');
          } else {
            that.$('.drop-zone').removeClass('hover');
          }
        },
        handleFileInput = function handleFileInput(source) {
          var files = FileAPI.getFiles(source);
          that.prepareFile(files[0]);
        };
      this._handleFileHover = handleFileHover;
      this._handleFileInput = handleFileInput;
      hiddenInput.attr('accept', '.csv');
      FileAPI.event.dnd(this.el, handleFileHover, handleFileInput);
      FileAPI.event.on(hiddenInput.get(0), 'change', handleFileInput);
      this._fileapi = true;
    },
    showResultsView: function showResultsView() {
      this.renderValidationResults();
      this.showWizardPane('results');
    },
    showUploadView: function showUploadView() {
      this.showWizardPane('upload');
    },
    showSuccessView: function showSuccessView() {
      this.showWizardPane('submitted');
    },
    showWizardPane: function showWizardPane(name) {
      var activePane = this.getAllWizardPanes('.active'),
        chosenPane = this.getWizardPane(name),
        chosenNav = this.getWizardNav(name);
      activePane.removeClass('active');
      chosenPane.addClass('active');
      chosenNav.addClass('activated');
      chosenNav.nextAll().removeClass('activated');
    },
    getAllWizardPanes: function getAllWizardPanes(selector) {
      return this.$('[data-wizard-pane]' + selector);
    },
    getWizardPane: function getWizardPane(name) {
      return this.$('[data-wizard-pane=' + name + ']');
    },
    getWizardNav: function getWizardNav(name) {
      return this.$('[data-wizard-step=' + name + ']');
    },
    updateWizardActions: function updateWizardActions() {
      var activePane = this.$('.wizard-pane.active'),
        delegate = this.getDelegate();
      switch (activePane.data('wizard-pane')) {
        case 'upload':
          this.toggleClass(activePane.find('[data-wizard-action]'), 'disabled', !delegate.getFile());
          break;
      }
    },
    toggleClass: function toggleClass(el, className, add) {
      if (add) {
        el.addClass(className);
      } else {
        el.removeClass(className);
      }
    },
    destroy: function destroy() {
      if (this._fileapi) {
        FileAPI.event.dnd.off(this.el, this._handleFileHover, this._handleFileInput);
        FileAPI.event.off(this.$(this.selectors.hiddenInput).get(0), 'change', this._handleFileInput);
      }
      RSAbstractContentView.prototype.destroy.apply(this, arguments);
    }
  });
  return LegacyUploadView;
});

